import React, { Suspense } from 'react';
import HeaderMenu, { MenuItems } from './HeaderMenu/HeaderMenu';
import { PillarContent } from './PillarContent';
import { HomeContent } from './HomeContent';
import { Footer, FooterProps } from './Footer/Footer';
import { FooterEn } from './Footer/FooterEn';
import { FooterUa } from './Footer/FooterUa';
import { ProgrammeContent } from './ProgrammeContent';
import { PositionsContent } from './PositionsContent';
import { PeopleContent } from './PeopleContent';
import { PageContent } from './PageContent';
import { ArticleContent } from './ArticleContent';
import { NewsListContent } from './NewsListContent';
import { ItemComponentProps } from './components/Articles';
import { ContactContent } from './ContactContent';
import { SearchContent } from './SearchContent';

export enum ContentComponents {
  HomeContentComponent,
  PillarContentComponent,
  ProgrammeContentComponent,
  PeopleContentComponent,
  PageContentComponent,
  PositionsContentComponent,
  NewsListContentComponent,
  ArticleComponent,
  ContactComponent,
  SearchComponent,
}

export interface AppProps {
  mainComponentName: ContentComponents;
  mainMenu: MenuItems,
  footerNews: ItemComponentProps[] | undefined;
  pathname: string,
  language: string,
  [propName: string]: any;
}

const AnyComponentFromProps: React.FC<AppProps> = (props) => {
  let Component: React.FC<any> | null = null;
  switch (props.mainComponentName) {
    case ContentComponents.HomeContentComponent:
      Component = HomeContent;
      break;
    case ContentComponents.PillarContentComponent:
      Component = PillarContent;
      break;
    case ContentComponents.ProgrammeContentComponent:
      Component = ProgrammeContent;
      break;
    case ContentComponents.PeopleContentComponent:
      Component = PeopleContent;
      break;
    case ContentComponents.PositionsContentComponent:
      Component = PositionsContent;
      break;
    case ContentComponents.NewsListContentComponent:
      Component = NewsListContent;
      break;
    case ContentComponents.ArticleComponent:
      Component = ArticleContent;
      break;
    case ContentComponents.PageContentComponent:
      Component = PageContent;
      break;
    case ContentComponents.ContactComponent:
      Component = ContactContent;
      break;
    case ContentComponents.SearchComponent:
      Component = SearchContent;
      break;
    default:
      console.error('Unsupported content type!');
  }

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
};

const FooterForLanguage = (props: FooterProps & { language: string }) => {
  switch (props.language) {
    case 'en':
      return <FooterEn {...props} />;
    case 'ua':
      return <FooterUa {...props} />;
    default:
      return <Footer {...props} />;
  }
};

export const App: React.FC<AppProps> = (props) => (
  <>
    <Suspense fallback={null}>
      <HeaderMenu {...props} />
    </Suspense>
    <Suspense fallback={null}>
      <AnyComponentFromProps {...props} />
    </Suspense>
    <Suspense fallback={null}>
      <FooterForLanguage news={props.footerNews} pathname={props.pathname} language={props.language} />
    </Suspense>
  </>
);
